var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBesticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "best_icon",
    "data-name": "best icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3966",
    "data-name": "Rectangle 3966",
    width: 24,
    height: 24,
    fill: "#898989"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 38,
    height: 38,
    fill: "#898989",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16172",
    "data-name": "Group 16172",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16172-2",
    "data-name": "Group 16172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16171",
    "data-name": "Group 16171",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28254",
    "data-name": "Path 28254",
    d: "M11.725,22.95A11.225,11.225,0,1,1,22.95,11.725,11.237,11.237,0,0,1,11.725,22.95m0-21.459A10.234,10.234,0,1,0,21.959,11.725,10.243,10.243,0,0,0,11.725,1.49",
    transform: "translate(-0.335 0.885)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28255",
    "data-name": "Path 28255",
    d: "M11.39,22.78a11.355,11.355,0,1,1,4.437-.894A11.4,11.4,0,0,1,11.39,22.78Zm0-22.45A11.06,11.06,0,1,0,22.45,11.39,11.072,11.072,0,0,0,11.39.33Zm0,21.459a10.4,10.4,0,1,1,10.4-10.4A10.411,10.411,0,0,1,11.39,21.789Zm0-20.469A10.069,10.069,0,1,0,21.459,11.39,10.081,10.081,0,0,0,11.39,1.321Z",
    transform: "translate(0 1.22)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28256",
    "data-name": "Path 28256",
    d: "M21.773,44.368A6.27,6.27,0,0,1,15.5,38.1a.508.508,0,0,1,.5-.5H27.55a.508.508,0,0,1,.5.5,6.27,6.27,0,0,1-6.273,6.273M16.523,38.59a5.272,5.272,0,0,0,10.5,0Z",
    transform: "translate(-10.383 -23.966)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28257",
    "data-name": "Path 28257",
    d: "M21.438,44.2A6.43,6.43,0,0,1,15,37.76a.669.669,0,0,1,.66-.66H27.215a.669.669,0,0,1,.66.66A6.43,6.43,0,0,1,21.438,44.2ZM15.66,37.43a.343.343,0,0,0-.33.33,6.108,6.108,0,0,0,12.215,0,.343.343,0,0,0-.33-.33Zm5.777,5.777a5.4,5.4,0,0,1-3.665-1.434,5.489,5.489,0,0,1-1.749-3.5l-.018-.181H26.867l-.015.179a5.376,5.376,0,0,1-1.737,3.5A5.431,5.431,0,0,1,21.438,43.208Zm-5.064-4.787a5.106,5.106,0,0,0,10.13,0Z",
    transform: "translate(-10.048 -23.632)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28258",
    "data-name": "Path 28258",
    d: "M17.689,22.472a.508.508,0,0,1-.5-.5,1.561,1.561,0,0,0-3.1,0,.5.5,0,1,1-.99,0,2.548,2.548,0,0,1,5.084,0,.486.486,0,0,1-.5.5",
    transform: "translate(-8.775 -11.909)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28259",
    "data-name": "Path 28259",
    d: "M17.354,22.3a.669.669,0,0,1-.66-.66,1.4,1.4,0,0,0-2.773,0,.66.66,0,1,1-1.321,0A2.632,2.632,0,0,1,15.307,19.1a2.632,2.632,0,0,1,2.707,2.542A.653.653,0,0,1,17.354,22.3ZM15.307,20.09a1.642,1.642,0,0,1,1.717,1.552.343.343,0,0,0,.33.33.323.323,0,0,0,.33-.33,2.3,2.3,0,0,0-2.377-2.212,2.3,2.3,0,0,0-2.377,2.212.33.33,0,1,0,.66,0A1.642,1.642,0,0,1,15.307,20.09Z",
    transform: "translate(-8.44 -11.574)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28260",
    "data-name": "Path 28260",
    d: "M45.089,22.472a.508.508,0,0,1-.5-.5,1.48,1.48,0,0,0-1.552-1.387,1.458,1.458,0,0,0-1.552,1.387.5.5,0,1,1-.99,0,2.548,2.548,0,0,1,5.084,0,.508.508,0,0,1-.5.5",
    transform: "translate(-27.129 -11.909)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28261",
    "data-name": "Path 28261",
    d: "M44.754,22.3a.669.669,0,0,1-.66-.66,1.313,1.313,0,0,0-1.387-1.222,1.3,1.3,0,0,0-1.387,1.222.66.66,0,0,1-1.321,0,2.713,2.713,0,0,1,5.414,0A.669.669,0,0,1,44.754,22.3ZM42.707,20.09a1.642,1.642,0,0,1,1.717,1.552.33.33,0,1,0,.66,0,2.383,2.383,0,0,0-4.754,0,.33.33,0,1,0,.66,0A1.623,1.623,0,0,1,42.707,20.09Z",
    transform: "translate(-26.794 -11.574)",
    fill: "#898989"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesticon);
export default __webpack_public_path__ + "static/media/besticon.0ccb6a66a52d2a7b0fd46f980f084409.svg";
export { ForwardRef as ReactComponent };